import React from 'react';
import { twMerge } from 'tailwind-merge';

export function IconFlag({ onClick, className, color = 'currentColor', strokeWidth = '2' }) {
  return (
    <svg
      onClick={onClick}
      className={twMerge('w-6 h-6', className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <line
        x1="4"
        y1="22"
        x2="4"
        y2="15"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
